/* sk8 Monster Drops, tema PS2, hero.js.
   Dono: frente 2 (hero). Os dois videos do skatista (16:9 no computador,
   9:16 no celular) so tocam com a hero na tela; qual dos dois esta visivel
   quem decide e o CSS por breakpoint (hero.css), aqui so liga e desliga o
   play do que estiver de fato aparecendo. Carrega em
   sections/hero-skatista.liquid, depois de base.js (usa SK8.$, SK8.$$). O
   mecanismo do "Comprar agora" (zoom + cortina + chegada) mora em base.js,
   porque vale em qualquer pagina; aqui so o que e exclusivo da hero.
   O texto em baixa resolucao de PS2 mora em hero-texto.js (async). */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$, $$ = SK8.$$;

  var hero = $(".hero");
  var videos = hero ? $$("video", hero) : [];
  if (videos.length && "IntersectionObserver" in window) {
    var naTela = false;
    function tocar() {
      videos.forEach(function (v) {
        var aparece = v.offsetParent !== null;
        // so o video visivel ganha o src: o do outro aparelho nunca baixa
        if (aparece && !v.getAttribute("src") && v.dataset.src) { v.src = v.dataset.src; v.preload = "auto"; }
        if (naTela && aparece) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }
    new IntersectionObserver(function (es) { naTela = es[0].isIntersecting; tocar(); }, { threshold: 0.05 }).observe(hero);
    // troca de video so quando cruza o ponto de quebra do hero.css (1000 px), e
    // nao a cada "resize": no celular a barra de endereco que some e volta na
    // rolagem dispara resize o tempo todo (leveza, 27/09/2026)
    var pc = window.matchMedia && matchMedia("(min-width: 1000px)");
    if (pc && pc.addEventListener) pc.addEventListener("change", tocar);
    else if (pc && pc.addListener) pc.addListener(tocar);
    else window.addEventListener("resize", tocar);
  }

  window.SK8 = SK8;
})();
